var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',[_c('div',{staticClass:"data-title"},[(_vm.h4)?_c('h4',[_vm._v(_vm._s(_vm.label))]):_c('h3',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"data-content data-clean text-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }